<template>
  <div>
    <ts-page-title
      :title="$t('productAddonInfo.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('productAddonInfo.pageTitle'),
          active: true
        }
      ]"
    />
    <ts-card>
      <Tabs @on-click="changeTab">
        <TabPane label="Assigned" icon="ios-analytics-outline">
          <assigned ref="assigned"></assigned>
        </TabPane>
        <TabPane label="Not yet assign" icon="ios-timer-outline">
          <not-assign ref="not_assign"></not-assign>
        </TabPane>
      </Tabs>
    </ts-card>
  </div>
</template>

<script>
import Assigned from './assigned'
import NotAssign from './not-assign'

export default {
  name: 'productAddonInfo',
  components: {
    Assigned,
    NotAssign
  },
  data () {
    return {}
  },
  methods: {
    changeTab (e) {
      if (e == 0) {
        this.$refs.assigned.fetchData()
      } else {
        this.$refs.not_assign.fetchData()
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('report/inventory/productAddonInfo/RESET_STATE')
    next()
  }
}
</script>
